module.exports = __webpack_public_path__ + "media/images/icono-usuario-outline-8c961582.svg";